<template>
  <transition>
    <div>
      <div
        class="nav-container"
        v-bind:class="{ 'nav-container--open': opened }"
      >
        <nav
          role="navigation"
          class="nested-menu"
          v-bind:class="{ 'nested-menu--disabled': isAnimating }"
        >
          <top-level-nav></top-level-nav>
          <p class="nested-menu__description nested-menu__description--local">
            {{ description }}
          </p>
          <ul
            class="nested-menu__list"
            v-bind:class="{
              'nested-menu__list--opened': $router.currentRoute.params.parentId,
            }"
          >
            <router-link
              v-for="parent in config"
              :key="parent.slug()"
              v-bind:to="{
                name: `${nav}.overview`,
                params: { parentId: parent.slug() },
              }"
              active-class="nested-menu__item--active"
              v-bind:class="{ [`nested-menu__item--${parent.slug()}`]: true }"
              class="nested-menu__item nested-menu__item--parent"
              tag="li"
            >
              <span v-bind:style="{ color: parent.colour() || '#0B3442' }">{{
                parent.title()
              }}</span>
              <ul class="nested-menu__list" v-bind:if="parent.hasChildren()">
                <router-link
                  v-bind:to="{ name: `${nav}` }"
                  aria-label="Close"
                  class="nested-menu__list-close"
                  >X</router-link
                >
                <li class="nested-menu__children-title">
                  <h3 v-bind:style="{ color: parent.colour() || '#FFA612' }">
                    {{ parent.title() }}
                  </h3>
                </li>
                <router-link
                  v-for="item in parent.children().sortedList()"
                  :key="item.slug()"
                  v-bind:to="{
                    name:
                      item.slug() === parent.overview()
                        ? `${nav}.overview`
                        : `${nav}.overview.details`,
                    params: {
                      parentId: parent.slug(),
                      id:
                        item.slug() === parent.overview()
                          ? undefined
                          : item.slug(),
                    },
                  }"
                  class="
                    nested-menu__item
                    nested-menu__item--child
                    nested-menu__item--local
                  "
                  v-bind:class="{
                    [`nested-menu__item--${parent.slug()}`]: true,
                    'nested-menu__item--active':
                      item.slug() === $router.currentRoute.params.id ||
                      (!$router.currentRoute.params.id &&
                        item.slug() === parent.overview()),
                  }"
                  tag="li"
                >
                  <span>{{ item.title() }}</span>
                  <ul
                    class="nested-menu__list nested-menu__list--grandchildren"
                    v-if="item.includeChildrenInNav() && item.hasChildren()"
                  >
                    <li
                      v-for="grandchild in item.children().sortedList()"
                      :key="grandchild.slug()"
                    >
                      <router-link
                        v-bind:to="{
                          name: `${nav}.overview.grandchildDetails`,
                          params: {
                            parentId: parent.slug(),
                            id: item.slug(),
                            grandchild: grandchild.slug(),
                          },
                        }"
                        >{{ grandchild.title() }}</router-link
                      >
                    </li>
                  </ul>
                </router-link>
              </ul>
            </router-link>
          </ul>
          <a
            class="nav__find-your-site"
            href="https://investsurrey.ca/market-intelligence/site-selector-tool"
            target="_blank"
          >
            Find Your Site
          </a>
        </nav>
        <button
          class="nav-toggle"
          v-if="toggleActive"
          v-bind:class="{ 'nav-toggle--open': opened }"
          v-on:click="toggle()"
        ></button>
      </div>
      <button
        class="mobile-hamburger"
        v-if="toggleActive"
        v-bind:class="{ 'mobile-hamburger--open': opened }"
        v-on:click="toggle()"
      ></button>
      <ul
        class="mobile-subnav"
        v-if="activeParent"
        v-bind:class="{ 'mobile-subnav--open': isMobileSubNavOpened }"
        @click="toggleMobileSubNav()"
      >
        <li
          class="mobile-subnav__invoker"
          
        >
          {{ activeParent.title() }}
        </li>
        <router-link
          active-class="mobile-subnav__child--active"
          v-bind:to="{
            name: `${nav}.overview.details`,
            params: { parentId: activeParent.slug(), id: child.slug() },
          }"
          tag="li"
          class="mobile-subnav__child"
          v-for="child in activeParent.children().sortedList()"
          :key="child.id()"
        >
          {{ child.title() }}

          <ul v-if="child.includeChildrenInNav() && child.hasChildren()">
            <li
              v-for="grandchild in child.children().sortedList()"
              :key="grandchild.slug()"
            >
              <router-link
                active-class="mobile-subnav__grandchild--active"
                v-bind:to="{
                  name: `${nav}.overview.grandchildDetails`,
                  params: {
                    parentId: activeParent.slug(),
                    id: child.slug(),
                    grandchild: grandchild.slug(),
                  },
                }"
              >
                {{ grandchild.title() }}
              </router-link>
            </li>
          </ul>
        </router-link>
      </ul>
    </div>
  </transition>
</template>
<script>
import TopLevelNav from '@/components/TopLevelNav';

export default {
  data() {
    return {
      nav: 'local',
      isMobileSubNavOpened: false,
    };
  },
  props: [
    'config',
    'opened',
    'toggleActive',
    'description',
    'isAnimating',
    'activeParent',
  ],
  components: { TopLevelNav },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
    toggleMobileSubNav() {
      this.isMobileSubNavOpened = !this.isMobileSubNavOpened;
    },
  },
};
</script>
<style lang="scss">
@import "../main.scss";
@media (max-width: 600px) {
  .mobile-subnav {
    position: fixed;
    top: 5.5rem;
    left: 0;
    right: 0;
    background: #092532;
    list-style: none;
    margin: 0;
    padding: 0;
    text-transform: none;
    font-size: 1.3rem;
    z-index: 999;
  }

  .mobile-subnav__invoker {
    padding: 0.4rem 1.2rem;
    border-bottom: solid 0.5px rgba(#939393, 0.7);
    color: white;
    position: relative;

    &:before {
      position: absolute;
      content: "";
      border-left: solid 2px $appPrimary;
      border-bottom: solid 2px $appPrimary;
      transform-origin: 50% 50%;
      width: 10px;
      height: 10px;
      right: .5rem;
      top: 50%;
      margin-top: -7px;
      transform: rotate(45deg);
    }

  }

  .mobile-subnav--open .mobile-subnav__invoker:before {
    transform: rotate(315deg);
  }

  .mobile-subnav__child {
    display: none;

    color: white;
    text-decoration: none;
    padding: 0.4rem 1.2rem;
    &:hover,
    &:active,
    &.mobile-subnav__child--active {
      color: $appPrimary;
    }

    > ul {
      display: none;
      list-style: none;
      margin: 0 0 0 0;
      padding: 0;
      > li {
        padding-left: 1.4rem;
        background: url("/static/marker-local-group.svg") no-repeat;
        background-size: 6px;
        background-position: 2px 6px;
      }

      a {
        color: white;
        text-decoration: none;
        &:hover,
        &:active,
        &.mobile-subnav__grandchild--active {
          color: $appPrimary;
        }
      }
    }

    &.mobile-subnav__child--active {
      > ul {
        display: block;
      }
    }
  }

  .mobile-subnav--open .mobile-subnav__child {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LocalNav.vue